module.exports = __webpack_public_path__ + "img/bb4b615.png";